module.exports = require("socks-proxy-agent");